import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

export async function getBooks(appointment_vendor, appointment_status = "", 
  appointment_website = "",appointment_location="", page_no = 0, search_key = "") {
  try {
    const fd = new FormData();
    fd.append("appointment_vendor", appointment_vendor);
    fd.append("appointment_status", appointment_status);
    fd.append("appointment_website", appointment_website);
    fd.append("appointment_location", appointment_location);
    fd.append("page_no", page_no);
    fd.append("search_key", search_key);

    const response = await axios.post(`${apiBaseUrl}book/get_books`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getBooks error:", error);
    return { status: false, type: "danger", success: "Failed to fetch bookings" };
  }
}

// 🔹 Get Booking Report (total, pending, completed, canceled)
export async function getBookReport(appointment_vendor) {
  try {
    const fd = new FormData();
    fd.append("appointment_vendor", appointment_vendor);

    const response = await axios.post(`${apiBaseUrl}book/get_book_report`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getBookReport error:", error);
    return { status: false, type: "danger", success: "Failed to load booking report" };
  }
}

// 🔹 Create or Update Booking
export async function createBook(
  appointment_id = "",
  appointment_page = "",
  appointment_page_title = "",
  appointment_vendor = "",
  appointment_customer_name = "",
  appointment_customer_email = "",
  appointment_customer_contact = "",
  appointment_slot = "",
  appointment_date = "",
  appointment_meet = "",
  appointment_meet_bot = "",
  appointment_calender = "",
  appointment_mode = "",
  appointment_status = "",
  appointment_payment_status = "",
  appointment_amt = "",
  appointment_pay_type = "",
  appointment_website = "",
  appointment_location = ""
) {
  try {
    const fd = new FormData();
    fd.append("appointment_id", appointment_id);
    fd.append("appointment_page", appointment_page);
    fd.append("appointment_location", appointment_location);
    fd.append("appointment_page_title", appointment_page_title);
    fd.append("appointment_vendor", appointment_vendor);
    fd.append("appointment_customer_name", appointment_customer_name);
    fd.append("appointment_customer_email", appointment_customer_email);
    fd.append("appointment_customer_contact", appointment_customer_contact);
    fd.append("appointment_slot", appointment_slot);
    fd.append("appointment_date", appointment_date);
    fd.append("appointment_meet", appointment_meet);
    fd.append("appointment_meet_bot", appointment_meet_bot);
    fd.append("appointment_calender", appointment_calender);
    fd.append("appointment_mode", appointment_mode);
    fd.append("appointment_status", appointment_status);
    fd.append("appointment_payment_status", appointment_payment_status);
    fd.append("appointment_amt", appointment_amt);
    fd.append("appointment_pay_type", appointment_pay_type);
    fd.append("appointment_website", appointment_website);

    const response = await axios.post(`${apiBaseUrl}book/create_book`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("createBook error:", error);
    return { status: false, type: "danger", success: "Failed to save booking" };
  }
}


// 🔹 Delete Booking
export async function deleteBook(appointment_id) {
  try {
    const fd = new FormData();
    fd.append("appointment_id", appointment_id);

    const response = await axios.post(`${apiBaseUrl}book/delete_book`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("deleteBook error:", error);
    return { status: false, type: "danger", success: "Booking delete failed" };
  }
}

// 🔹 Update Booking Status
export async function updateBookStatus(appointment_id, appointment_status) {
  try {
    const fd = new FormData();
    fd.append("appointment_id", appointment_id);
    fd.append("appointment_status", appointment_status);

    const response = await axios.post(`${apiBaseUrl}book/update_book_status`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("updateBookStatus error:", error);
    return { status: false, type: "danger", success: "Status update failed" };
  }
}
export const rescheduleAppointment = async (id, date, slot) => {
  const form = new FormData();
  form.append("appointment_id", id);
  form.append("new_date", date);
  form.append("new_slot", slot);

  const res = await axios.post(apiBaseUrl + "book/reschedule_appointment", form);
  return res.data;
};

export async function getAvailableSlots(booking_page_id, date) {
  try {
    
    const fd = new FormData();
    fd.append("booking_page_id", booking_page_id);
    fd.append("date", date);

    const res = await axios.post(
      `${apiBaseUrl}book/get_available_slots`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return res.data;
  } catch (err) {
    console.error("getAvailableSlots error:", err);
    return {
      status: false,
      success: "Failed to get available slots"
    };
  }
}

export async function getAppointmentById(id) {
  const fd = new FormData();
  fd.append("appointment_id", id);

  return await axios
    .post(`${apiBaseUrl}book/get_appointment_by_id`, fd)
    .then((r) => r.data)
    .catch(() => ({ status: false, success: "Server Error" }));
}

